import { ScheduleDto, ScheduleInfoDto } from "../dtos/scheduleDto";
import { Schedule, ScheduleInfo } from "@lib/types";

/** Schedule mapper. */
class ScheduleMapper {

    /**
     * Maps dto to model.
     * @param dto Dto.
     */
    public fromDto(dto: ScheduleDto): Schedule {
        return {
            scheduleId: dto.scheduleId,
            path: dto.path,
            fullPath: dto.fullPath,
            name: dto.name,
            description: dto.description,
            isEnabledFb: dto.enabled_fb,
            isEnabledHmi: dto.enabled_hmi,
            isLocked: dto.locked,
        };
    }

    /**
     * Maps schedule info dto to model.
     * @param dto Dto.
     */
    public fromScheduleInfoDto(dto: ScheduleInfoDto): ScheduleInfo {
        return {
            scheduleId: dto.scheduleId,
            path: dto.path,
            isEnabledFb: dto.enabled_fb,
            isEnabledHmi: dto.enabled_hmi,
            isLocked: dto.locked,
        };
    }
}

export const scheduleMapper = new ScheduleMapper();
